
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardActionArea, Grid, Typography } from "@mui/material";
import { iconos } from "../../../data";




export const CardDetalles = ({ item }) => {

    

    const navigate = useNavigate();
    const IconComponent = iconos[item.icon] || iconos['micuente'];


    const handleIrOpcion = useCallback(() => {
        if (item?.route) {
            navigate(item.route);
        } else if (typeof item?.funcion === 'function') {
            item.funcion();
        }
    }, [item, navigate]);




    return (

        <Grid item xs={12} sm={6} md={4}>
            <Card
                sx={{
                position: 'relative',
                height: 180,
                borderRadius: 4,
                overflow: 'hidden',
                border: '1px solid rgba(0,0,0,0.06)',
                transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            
                }}
            >
                <CardActionArea onClick={ handleIrOpcion }
                    sx={{ height:'100%', display:'flex', flexDirection:'column', alignItems:'flex-start', 
                        justifyContent:'center', padding:3, position:'relative', zIndex:1
                }}>
                    <Box sx={{ width:70, height:70, borderRadius:3, background:item.gradient, display:'flex', 
                        alignItems:'center', justifyContent:'center', marginBottom:1, border:'2px solid rgba(255,255,255,0.8)',
                        transition:'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    }}>
                        {React.cloneElement(IconComponent, { style: {fontSize:36, color:'white', filter:'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' }})}
                    </Box>

                    <Box sx={{ width:'100%' }}>
                        <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', mb:0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight:800, fontSize:'1.2rem', lineHeight:1.3, color:'#ffffff', 
                                letterSpacing:'-0.03em', filter:'brightness(1.1)'
                            }}>
                                { item.title }
                            </Typography>
                        </Box>
                        
                        <Typography variant="body2" sx={{ color:'#94a3b8', lineHeight:1.5, fontSize:'0.9rem', textAlign:'center' }}>
                            {item.description}
                        </Typography>
                    </Box>
                </CardActionArea>

                <Box sx={{ position:'absolute', bottom:0, left:0, right:0, height:5, 
                    background:item.gradient, transition:'height 0.3s ease', boxShadow:`0 -2px 10px ${item.color}40`
                }} />

                <Box sx={{ position:'absolute', top:-30, right:-30, width:120, height:120, pointerEvents:'none', zIndex:0,
                    borderRadius:'50%', background:`radial-gradient(circle, ${item.color}15 0%, transparent 70%)`,
                }} />
            </Card>
        </Grid>
    )
}
